import { Box } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { customEvent, getCdnImageSrc, NextLink } from "goi_common";

const GUIDEBOOKS = [
  {
    title: "장례 절차와 일정\n한눈에 보기",
    tag: "임종 전",
    to: "/guidebook/summary/before/funeral-process/",
    backgroundSrc: getCdnImageSrc("images/guidebook/guidebook_info_1.png"),
  },
  {
    title: "상조 서비스\n유형과 비용\n한눈에 보기",
    tag: "임종 전",
    to: "/guidebook/summary/before/service-type/",
    backgroundSrc: getCdnImageSrc("images/guidebook/guidebook_info_2.png"),
  },
  {
    title: "장례식장\n한눈에 보기",
    tag: "임종 전",
    to: "/guidebook/summary/parlor/",
    backgroundSrc: getCdnImageSrc("images/guidebook/guidebook_info_4.png"),
  },
  {
    title: "장지\n한눈에 보기",
    tag: "임종 후",
    to: "/guidebook/summary/facility/",
    backgroundSrc: getCdnImageSrc("images/guidebook/guidebook_info_5.png"),
  },
  {
    title: "장례 후 절차와\n체크리스트\n한눈에 보기",
    tag: "장례 후",
    to: "/guidebook/summary/after/checklist/",
    backgroundSrc: getCdnImageSrc("images/guidebook/guidebook_info_3.png"),
  },
];

export function GuidebookCarousel() {
  return (
    <NoScrollBarBox display="flex" flex="column" overflow="scroll" marginTop="12px">
      {GUIDEBOOKS.map((book, i) => (
        <>
          {i === 0 && <div key={i + "spacing"} css={{ width: "0px", margin: "10px" }}></div>}

          <GuidebookCarouselItem
            key={book.title}
            title={book.title}
            tag={book.tag}
            backgroundSrc={book.backgroundSrc}
            to={book.to}
          />
        </>
      ))}
    </NoScrollBarBox>
  );
}

const NoScrollBarBox = styled(Box)`
  ::-webkit-scrollbar {
    display: none;
  }
`;

const GuidebookCarouselItem = ({
  title,
  tag,
  backgroundSrc,
  to,
}: {
  title: string;
  tag: string;
  backgroundSrc: string;
  to: string;
}) => {
  return (
    <NextLink
      href={to}
      onClick={() => {
        customEvent({
          newGtm: {
            path: "guidebook",
            trigger_and_target: "info-uv_guidebook_summary",
            text: "title",
          },
        });
      }}
    >
      <Box
        display="flex"
        width="184px"
        minWidth="184px"
        height="210px"
        padding="40px 24px 24px"
        borderRadius="24px"
        whiteSpace="pre"
        backgroundImage={backgroundSrc}
        color="white"
        flexDirection="column"
        justifyContent="space-between"
        //   boxShadow="0px 2px 4px rgba(0, 0, 0, 0.16)"
        backgroundSize="cover"
        mr="12px"
        cursor="pointer"
      >
        <Box className="subtitle2_sb">{title}</Box>
        <Box
          width="fit-content"
          className="body3_r"
          border="1px solid white"
          borderRadius="30px"
          padding="8px 18px"
        >
          {tag}
        </Box>
      </Box>
    </NextLink>
  );
};
